
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" v-on="$listeners" :fill="color"
    >
      <path d="M8.8 11.933a1 1 0 01-1.6 0L3.2 6.6A1 1 0 014 5h8a1 1 0 01.8 1.6l-4 5.333z"></path>
    </svg>
  </template>
  <script>
    export default {
      name: "IconDown",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    };
  </script>
